const DisplayModes = {
   Normal: 'normal',
   Theater: 'theater',
   Fullscreen: 'fullscreen',
   PictureInPicture: 'picture-in-picture'
};

export default DisplayModes;
